










































































































import FeedbackComponent from '@/components/base/FeedbackComponent'
import SearchMember from "@/components/dashboard/customer-service/components/SearchMember.vue";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import Component from 'vue-class-component'
import {Action} from "vuex-class";


@Component({
  components: {
    SearchMember,
  }
})
export default class OfficerConfig extends FeedbackComponent {

  @Action('officerLoanRemove', StoreNamespace.LOAN_CONFIG) officerLoanRemove: any;
  @Action('officerLoanGetAll', StoreNamespace.LOAN_CONFIG) officerLoanGetAll: any;
  @Action('officerLoanAdd', StoreNamespace.LOAN_CONFIG) officerLoanAdd: any;

  private searchCRMStatus: string = ""
  private statusesList: any[] = []
  private showEditCRMStatusModal: boolean = false
  private currentCRMStatus: any = {memberIdNumber: "", fullName: "", id: -1}

  mounted() {
    this.officerLoanGetAll({
      requestorCallback: this
    })
  }

  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'officerLoan/getAll':
        this.statusesList = data
        break;
      case 'officerLoan/remove':
      case 'officerLoan/add':
        this.officerLoanGetAll({
          requestorCallback: this
        })
        this.onHideEditArrivalSourceModal()
        this.showSuccessAction(this.$t('OfficerLoan.createOrUpdateStatusesSuccessMessage') as string)
        break;
    }
  }

  get filteredActiveCRMStatusesList(): any[] {
    if (!this.searchCRMStatus) {
      this.searchCRMStatus = ""
    }

    return this.statusesList.filter((source: any) => {
      return source.memberIdNumber.toString().includes(this.searchCRMStatus) ||
          source.fullName.toString().includes(this.searchCRMStatus)
    })
  }

  onShowCreateOrUpdateArrivalSource() {
    this.showEditCRMStatusModal = true
  }

  onHideEditArrivalSourceModal() {
    this.currentCRMStatus = {memberIdNumber: "", fullName: "", id: -1}
    this.showEditCRMStatusModal = false
  }

  onSaveStatus() {
    const body = {...this.currentCRMStatus}

    this.officerLoanAdd({
      requestorCallback: this,
      requestBody: body
    })
  }

  private showSuccessAction(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

  handleRemoveOfficer(status: any) {
    const body = {...status}

    this.officerLoanRemove({
      requestorCallback: this,
      requestBody: body
    })
  }

  private onSelectedMember(member: any) {
    this.currentCRMStatus.memberIdNumber = member.idNumber
    this.currentCRMStatus.fullName = member.fullName
  }

};
